import utils from '@/app/utils/gfUtils';
import config from '@/app/editor/config';

(function (jQuery) {
  jQuery.gfGenerateTokenInstagram = function (element, options) {
    const defaults = {
      title: '',
      onSelected: function () {},
    };

    this.settings = {};
    const $element = jQuery(element);
    const _this = this;

    const $gfLeftSideBar = jQuery('#gfLeftSideBar');

    this.init = function () {
      this.settings = jQuery.extend({}, defaults, options);
      $element.hide();

      $element.after(
        '<a id="gf-pick-link" class="button" href="#" style="padding-top: 10px; padding-bottom: 10px;width: 150px; margin-bottom: 15px;">' +
          utils.svgIcon('touch-finger') +
          ' Generate Token</a>',
      );

      const $generateToken = $element.next();
      $generateToken.click(function () {
        _this.getToken();
      });
    };

    this.setToken = function (token) {
      sessionStorage.removeItem('instaImagesJSON');
      sessionStorage.removeItem('first-loading');

      $gfLeftSideBar
        .find('#token')
        .attr('value', token)
        .val(token)
        .trigger('value-change')
        .trigger('input-change')
        .trigger('history-change');
    };

    this.getToken = function () {
      const client_id = config.__INSTAGRAM.__CLIENT_ID;
      const redirect_url = config.__INSTAGRAM.__REDIRECT_URL;
      let accessToken = null;
      // Pop-up window size, change if you want
      const popupWidth = 700,
        popupHeight = 500,
        popupLeft = (window.screen.width - popupWidth) / 2,
        popupTop = (window.screen.height - popupHeight) / 2;

      // Url needs to point to instagram_auth.php
      const popup = window.open(
        '',
        '',
        'width=' + popupWidth + ',height=' + popupHeight + ',left=' + popupLeft + ',top=' + popupTop + '',
      );
      popup.onload = function () {
        // Open authorize url in pop-up
        if (window.location.hash.length == 0) {
          popup.open('https://instagram.pixelunion.net/', '_self');
        }
        var interval = setInterval(function () {
          try {
            if (popup.location.href == undefined) {
              popup.close();
              clearInterval(interval);
            }
            if (popup.location.hash.length) {
              clearInterval(interval);
              accessToken = popup.location.hash.slice(14); //slice #access_token= from string
              popup.close();
              _this.setToken(accessToken);
            }
          } catch (evt) {
            // Permission denied
          }
        }, 100);
      };
    };

    this.init();
  };
  jQuery.fn.gfGenerateTokenInstagram = function (options) {
    return this.each(function () {
      if (undefined == jQuery(this).data('gfgeneratetokeninstagram')) {
        const plugin = new jQuery.gfGenerateTokenInstagram(this, options);
        jQuery(this).data('gfgeneratetokeninstagram', plugin);
      }
    });
  };
})(jQuery);
